import {
  SelfDescribingJson,
  trackSelfDescribingEvent,
} from '@snowplow/browser-tracker'
import {
  chatRoomContextSchema,
  ChatRoomContextSchemaData,
  groupContextSchema,
  GroupContextSchemaData,
  notificationContextSchema,
  NotificationContextSchemaData,
  postContextSchema,
  PostContextSchemaData,
  privacySettingsContextSchema,
  PrivacySettingsContextSchemaData,
  userContextSchema,
  UserContextSchemaData,
  vipPlanContextSchema,
  VipPlanContextSchemaData,
  letterContextSchema,
  LetterContextSchemaData,
} from '../schema'
import { SchemaDetail, schemaPath } from '../schema/types'

type Props = {
  event?: SelfDescribingJson
  schema?: SchemaDetail
  user?: UserContextSchemaData
  users?: UserContextSchemaData[]
  post?: PostContextSchemaData
  group?: GroupContextSchemaData
  groups?: GroupContextSchemaData[]
  notification?: NotificationContextSchemaData
  chatRoom?: ChatRoomContextSchemaData
  vipPlan?: VipPlanContextSchemaData
  privacySettings?: PrivacySettingsContextSchemaData
  letter?: LetterContextSchemaData
}

export const trackEvent = ({
  event,
  schema,
  user,
  users,
  post,
  group,
  groups,
  notification,
  chatRoom,
  vipPlan,
  privacySettings,
  letter,
}: Props) => {
  if (!event && !schema) return false

  trackSelfDescribingEvent({
    event: event ?? {
      schema: schemaPath(schema),
      data: {},
    },
    context: [
      user && userContextSchema(user),
      ...(users?.length ? users.map(userContextSchema) : []),
      post && postContextSchema(post),
      group && groupContextSchema(group),
      ...(groups?.length ? groups.map(groupContextSchema) : []),
      notification && notificationContextSchema(notification),
      chatRoom && chatRoomContextSchema(chatRoom),
      vipPlan && vipPlanContextSchema(vipPlan),
      privacySettings && privacySettingsContextSchema(privacySettings),
      letter && letterContextSchema(letter),
    ].filter(Boolean),
  })
}
